import { useState, useEffect } from 'react';
import { Car } from 'lucide-react';

/**
 * Deterministic vehicle image with a NEUTRAL fallback.
 * Renders the vehicle's own photo `src`; if `src` is missing OR the URL fails
 * to load, it shows a neutral "image unavailable" placeholder — NEVER another
 * vehicle's image. Reused across inventory cards, details and Command Center
 * panels so broken/missing photos degrade consistently and safely.
 */
export function VehicleImg({ src, alt, imgClassName, placeholderClassName, label = 'Image unavailable', iconClass = 'w-8 h-8' }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => { setFailed(false); }, [src]);  // reset when the vehicle/photo changes

    if (!src || failed) {
        return (
            <div className={`flex flex-col items-center justify-center gap-1 text-muted-foreground bg-muted ${placeholderClassName || ''}`}
                 data-testid="vehicle-img-placeholder" role="img" aria-label={label}>
                <Car className={`${iconClass} opacity-60`} />
                <span className="text-[10px] opacity-70">{label}</span>
            </div>
        );
    }
    return <img src={src} alt={alt || ''} className={imgClassName} loading="lazy" onError={() => setFailed(true)} />;
}
